import React  from "react";
import { useDispatch } from "react-redux";
import{ shouldDisplayAction, isDVAST } from 'utils/CreativeActions';
import { BasicAction } from "widgets/ActionMenu";
import { openModal } from 'reducers/Modal';
import { MODAL_TYPES } from 'utils/constants';

export function BasicApprovalAction(icon, name, className, rowInfo){
	const dispatch = useDispatch()
		;

	let handleClick = () => console.error(`Modal: ${name} not implemented`);

	if (name === 'Submit Ad') {
		handleClick = () => dispatch(openModal(MODAL_TYPES.SUBMIT_CREATIVES, {
			creatives: [{
				id: rowInfo.creativeId,
				name: rowInfo.creativeName,
				approval: rowInfo.approval,
				adType: rowInfo.adType,
			}],
			libraryId: rowInfo.libraryId,
		}));
	}

	if (name === 'Approve Ad') {
		handleClick = () => dispatch(openModal(MODAL_TYPES.APPROVE_CREATIVES, {
			creatives: [{
				id: rowInfo.creativeId,
				name: rowInfo.creativeName,
				approval: rowInfo.approval,
				adType: rowInfo.adType,
			}],
			libraryId: rowInfo.libraryId,
		}));
	}

	if(name === 'Recall Ad') {
		handleClick = () => dispatch(openModal(MODAL_TYPES.RECALL_CREATIVES, {
			creatives: [{
				id: rowInfo.creativeId,
				name: rowInfo.creativeName,
				approval: rowInfo.approval,
			}],
			libraryId: rowInfo.libraryId,
		}));
	}

	if (name === 'Reject Ad') {
		let { creativeName, creativeId, approval, libraryId } = rowInfo;
		handleClick = () =>  dispatch(openModal(MODAL_TYPES.REJECT_CREATIVES, {
			creatives:[{
				name: creativeName,
				id: creativeId,
				approval,
			}],
			libraryId,
		}));
	}

	if (name === 'View Approval History') {
		let { creativeName, creativeId, approval, libraryId } = rowInfo;
		handleClick = () =>  dispatch(openModal(MODAL_TYPES.APPROVAL_HISTORY, {
			creatives:[{
				name: creativeName,
				id: creativeId,
				approval,
			}],
			libraryId,
		}));
	}

	if (name === 'View Rejection Reason') {
		let { creativeName, creativeId } = rowInfo;
		handleClick = () =>  dispatch(openModal(MODAL_TYPES.VIEW_REJECT_REASON, {
			creatives:[{
				name: creativeName,
				id: creativeId,
				rejectNotes: rowInfo?.rejectNotes || '',
			}],
		}));
	}

	return (
		<BasicAction
			iconName={icon}
			name={name}
			className={className}
			handleClick={handleClick}
		/>
	);
}

export const SUBMIT_AD = {
	shouldDisplay: ({ user, dependentValues }) => shouldDisplayAction.submit(user, dependentValues),
	component: ({ dependentValues }) => BasicApprovalAction("fas fa-arrow-circle-right", "Submit Ad", "submit-to-qa-action", dependentValues),
};

export const APPROVE_AD = {
	shouldDisplay: ({ user, dependentValues }) => {
		if(isDVAST(dependentValues.adType)) {
			return shouldDisplayAction.approveDVAST(user, dependentValues);
		}

		return shouldDisplayAction.approve(user, dependentValues);
	},
	component:  ({ dependentValues })=>BasicApprovalAction("approved", "Approve Ad", "approve-action", dependentValues),
};

export const RECALL_AD = {
	shouldDisplay: ({ user, dependentValues }) => shouldDisplayAction.recall(user, dependentValues),
	component: ({ dependentValues })=>BasicApprovalAction("fas fa-arrow-circle-left", "Recall Ad", "recall-action", dependentValues),
};

export const REJECT_AD = {
	shouldDisplay: ({ user, dependentValues }) => shouldDisplayAction.reject(user, dependentValues),
	component: ({ dependentValues })=>BasicApprovalAction("fas fa-times-circle", "Reject Ad", "reject-action", dependentValues),
};

export const VIEW_APPROVAL_HISTORY = {
	name: "View Approval History",
	shouldDisplay: () => true,
	component: ({ dependentValues }) => BasicApprovalAction("fas fa-history", "View Approval History", "approval-history-action", dependentValues),
};

export const REJECTION_REASON = {
	shouldDisplay: ({ user, dependentValues }) => shouldDisplayAction.rejectionReason(user, dependentValues),
	component: ({ dependentValues }) => BasicApprovalAction("fas fa-comment-alt-lines", "View Rejection Reason", "view-rejection-action", dependentValues),
};

export const APPROVAL_ACTION_LIST = [
	[SUBMIT_AD, APPROVE_AD, RECALL_AD, REJECT_AD],
	[REJECTION_REASON, VIEW_APPROVAL_HISTORY]
];

export const PRIVATE = {
	APPROVAL_ACTION_LIST,
	SUBMIT_AD,
	APPROVE_AD,
	RECALL_AD,
	REJECT_AD,
	VIEW_APPROVAL_HISTORY,
	REJECTION_REASON,
};
